export default __webpack_public_path__ + "f41fe187da6c12ad357b7accc4e239a1.png";